import { ApplicationState } from '@/store';
import React from 'react';
import { useSelector } from 'react-redux';
import { GoToAppOrStoreStandard } from './GoToAppOrStoreStandard';
import { GoToAppOrStoreWhiteLabel } from './GoToAppOrStoreWhiteLabel';

export interface BtnConfig {
    label: string;
    action: () => void;
}

export interface GoToAppOrStoreProps {
    autoRedirect?: boolean;
    customBtnConfig?: BtnConfig;
}

const GoToAppOrStore: React.FC<GoToAppOrStoreProps> = (props) => {
    const { isWhiteLabel, isTotvs } = useSelector((state: ApplicationState) => state.appOrganization.data);
    return isWhiteLabel || isTotvs ? <GoToAppOrStoreWhiteLabel {...props} /> : <GoToAppOrStoreStandard {...props} />;
};

export default GoToAppOrStore;
